"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateJwtAsServiceUtil = void 0;
const jwt_util_1 = require("./jwt.util");
const generateJwtAsServiceUtil = (signSecret) => {
    const user = {
        id: -1,
        __typename: 'SERVICE',
    };
    return (0, jwt_util_1.sign)({
        payload: { user },
        secret: signSecret,
        expiresIn: '5m',
    });
};
exports.generateJwtAsServiceUtil = generateJwtAsServiceUtil;
